import { getItemTotalAmount } from "../../services/order-add-edit-service";
import { getOptionName } from "../../utils/Common";
import AdditionGroupsList from "../restaurants/orders/AdditionGroupsList";

export default function PaymentOrderItemRow({ item }) {

  return (
    <>
      <div
        className={`grid grid-cols-[1fr_6rem_4rem_10rem] gap-2 items-center ${
          item.hasBorder ? "" : "border-b"
        } border-gray-200 py-2`}
      >
        <div className="whitespace-normal break-all pr-5">{item.name}</div>
        <div className="line-clamp-1">{getOptionName(item.option.name)}</div>
        <div className="text-center font-ubold">QTY {String(item.quantity).padStart(2, "0")}</div>
        <div className="text-right">{getItemTotalAmount(item.quantity, item.option.price)} TK</div>
      </div>
      { item.addOns.length > 0 && 
        <div className={`grid grid-cols-[1fr_6rem_3rem_6rem] gap-2 py-1 items-center ${item.additionGroups.length > 0 ? '' : 'border-b'} border-gray-200`}>
          { item.addOns.map((addOn) => (
            <div key={`${addOn.id}-${item.id}`} className=" col-span-4 whitespace-normal break-all flex items-center justify-between text-[11px] font-medium text-[#341557]">
              <div> + {addOn.name}</div>
              <div>{getItemTotalAmount(item.quantity, addOn.price)} TK</div>
          </div>
          ))}
        </div>
      }
      {item.additionGroups.length > 0 && (
        <div className={`grid grid-cols-[1fr_6rem_3rem_6rem] gap-2 items-center border-b border-gray-200 py-1`}>
          <div className=" col-span-4 whitespace-normal break-all">
            <AdditionGroupsList  additionGroups={item.additionGroups}/>
          </div>
        </div>
      )}
    </>
  );
}
